import {
  Box,
  AspectRatio,
  usePropsResolution,
  Image,
  HStack,
} from 'native-base';
import React, { isValidElement } from 'react';
import { Text } from '../Text';
import { Heading } from '../Heading';
import type { IEmptyStateProps } from './EmptyState.types';

const EmptyState = ({
  direction = 'vertical',
  title,
  headerImage,
  body,
  footer,
  testID = 'EmptyState',
  ...props
}: IEmptyStateProps) => {
  const {
    _container,
    _bodyContainer,
    _descriptionContainer,
    _horizontalImage,
    _horizontalSVGContainer,
    _verticalImage,
    _verticalImageContainer,
    _title,
    _body,
    _footer,
  } = usePropsResolution('EmptyState', props);

  const renderVerticalImage = () => {
    if (!headerImage) {
      return null;
    }
    if (isValidElement(headerImage)) {
      return (
        <AspectRatio {..._verticalImageContainer}>{headerImage}</AspectRatio>
      );
    } else {
      return (
        <AspectRatio {..._verticalImageContainer}>
          <Image {..._verticalImage} {...headerImage} />
        </AspectRatio>
      );
    }
  };

  const renderHorizontalImage = () => {
    if (!headerImage) {
      return null;
    }
    if (isValidElement(headerImage)) {
      return (
        <AspectRatio {..._horizontalSVGContainer}>{headerImage}</AspectRatio>
      );
    } else {
      return <Image {..._horizontalImage} {...headerImage} />;
    }
  };

  return (
    <Box {..._container} testID={testID} {...props}>
      {direction === 'vertical' && renderVerticalImage()}
      <HStack {..._bodyContainer}>
        {direction === 'horizontal' && renderHorizontalImage()}
        <Box {..._descriptionContainer}>
          {title && (
            <Heading
              textAlign={direction === 'vertical' ? 'center' : 'left'}
              testID={`${testID}--Title`}
              {..._title}
            >
              {title}
            </Heading>
          )}
          {body && (
            <Text
              textAlign={direction === 'vertical' ? 'center' : 'left'}
              testID={`${testID}--Body`}
              {..._body}
            >
              {body}
            </Text>
          )}
        </Box>
      </HStack>
      {footer && (
        <Box testID={`${testID}--Footer`} {..._footer}>
          {footer}
        </Box>
      )}
    </Box>
  );
};

export default EmptyState;
